exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-preparation-progress-bar[data-v-55013c10] {\n  width: 100%;\n}\n.order-preparation-progress-bar .progress-text[data-v-55013c10] {\n  position: absolute;\n  color: black;\n  width: 100%;\n  text-align: center;\n  line-height: 2rem;\n}\n.order-preparation-progress-bar .progress[data-v-55013c10] {\n  height: 2rem !important;\n  font-size: 1.2rem;\n  position: relative;\n}", ""]);

// exports
